import apiService from './api.service';

export interface Role {
  id: string;
  tenant_id: string;
  name: string;
  description?: string;
  is_system: boolean;
  created_at: string;
  updated_at: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
}

class RoleApi {
  /**
   * Get all roles for the current tenant
   */
  async getAll(): Promise<ApiResponse<Role[]>> {
    const response = await apiService.get<ApiResponse<Role[]>>('/v1/roles');
    return response.data;
  }
}

export default new RoleApi();
